import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "left pe-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-9" }, "OneRepublic", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, " Add your video on the OneRepublic Image! ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Click below and choose your favorite video to be added into your interactive time capsule ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fs-14 mt-5" }, " Upload Your Video ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Please wait. Your video is uploading. Do not close the page. ")
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 3,
  for: "ff",
  class: "fileLabel"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\"><rect width=\"44\" height=\"44\" fill=\"none\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.706 12.4287H30.294C30.78 12.4287 31.262 12.5237 31.712 12.7107C32.162 12.8967 32.57 13.1697 32.914 13.5137C33.259 13.8577 33.532 14.2667 33.718 14.7167C33.904 15.1657 34 15.6477 34 16.1347V23.5397C33.998 26.2177 32.933 28.7857 31.038 30.6787C29.144 32.5717 26.575 33.6347 23.897 33.6347H13.706C13.22 33.6347 12.738 33.5387 12.288 33.3527C11.838 33.1667 11.43 32.8937 11.086 32.5487C10.741 32.2047 10.468 31.7967 10.282 31.3467C10.096 30.8967 10 30.4147 10 29.9287V16.1347C10 15.1517 10.39 14.2087 11.086 13.5137C11.781 12.8187 12.723 12.4287 13.706 12.4287V12.4287Z\" stroke=\"#4A4A4A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.865 21.1426H25.294\" stroke=\"#4A4A4A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.865 26.6348H21.079\" stroke=\"#4A4A4A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.865 11V13.849\" stroke=\"#4A4A4A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M27.135 11V13.849\" stroke=\"#4A4A4A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><p class=\"fs-14 ms-3 mb-0\"> My Phone/Camera roll </p>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card border-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/img.jpeg",
      class: "img-fluid card-img-top",
      alt: ""
    })
  ])
], -1)

import { LpApiService } from "@/services/lpApiService";
import { ref } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Page3',
  setup(__props) {

const route = useRoute();
const submitButtonDisabled = ref(false)
const videoUploaded = ref(false)
const uploadFile = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (!target || !target.files) return;

  const file = target.files[0];
  if (!file) return;

  submitButtonDisabled.value = true;

  try {
    await LpApiService.uploadVideo(file, route.query.code, route.query.email)
    videoUploaded.value = true;
  } catch (e) {
    console.log('response', e.response)
    alert('Error')
  } finally {
    submitButtonDisabled.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        (submitButtonDisabled.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_9
            ], 64))
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              onChange: uploadFile,
              type: "file",
              accept: "video/*",
              class: "fileChoose",
              name: "",
              id: "ff"
            }, null, 32)),
        (videoUploaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Done! Your video has been successfully uploaded and will work with the 1R app in 5 minutes or less . You can now close this page. "))
          : (!submitButtonDisabled.value)
            ? (_openBlock(), _createElementBlock("label", _hoisted_11, _hoisted_14))
            : _createCommentVNode("", true)
      ]),
      _hoisted_15
    ])
  ]))
}
}

})